import { MutableRefObject, useCallback, useMemo } from 'react';
import { t } from 'i18next';

import { PropertiesPopup } from '@/modules/common/components/PropertiesPopup';
import { PropertiesTitle } from '@/modules/common/components/PropertiesTitle';

import { useOrderProfileStore } from '../store/useOrderProfileStore';
import { OrderProfileServiceFactory } from '../service/OrderProfileServiceFactory';
import { OrderProfileProperties } from './OrderProfileProperties';

type Props = {
  anchor: MutableRefObject<HTMLElement | null>;
};

export function OrderProfilePanel({ anchor }: Props) {
  const { panelOpen } = useOrderProfileStore();
  const opSvc = useMemo(
    () => OrderProfileServiceFactory.getInstance().createOrderProfileService(),
    [],
  );

  const onClose = useCallback(() => {
    opSvc.setPanelOpen(false);
  }, [opSvc]);

  return (
    <PropertiesPopup
      anchor={anchor}
      open={panelOpen}
      onClose={onClose}
      header={
        <PropertiesTitle
          fontSize={14}
          fontWeight={400}
          value={t('interface:order_profile.add_title')}
        />
      }
      sx={{
        width: '391px',
        height: 'auto',
      }}
    >
      <OrderProfileProperties />
    </PropertiesPopup>
  );
}
